// frontend/src/pages/EmailVerificationPage.js
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { apiClient } from '../services/api'; // Your configured axios instance
import LoadingSpinner from '../components/Common/LoadingSpinner';
import useAuth from '../hooks/useAuth'; // To potentially log the user in

const EmailVerificationPage = () => {
  const { key } = useParams();
  const navigate = useNavigate();
  const { login } = useAuth(); // Get login function from AuthContext

  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const verifyEmail = async () => {
      if (!key) {
        setError('Verification key is missing or invalid.');
        setIsLoading(false);
        return;
      }
      setIsLoading(true);
      try {
        // dj_rest_auth.registration's verify-email endpoint expects a POST request
        const response = await apiClient.post('auth/registration/verify-email/', { key });
        
        setMessage(response.data?.detail || 'Your email has been successfully verified! You can now log in.');
        
        // Optional: If ACCOUNT_LOGIN_ON_EMAIL_CONFIRMATION is True in Django,
        // and dj-rest-auth returns a token upon successful verification + login,
        // you could attempt to log the user in here.
        // This depends on the exact response from your backend.
        // For now, we'll just redirect to login.
        // if (response.data && response.data.token && response.data.user) {
        //   login(response.data.token, response.data.user);
        //   setTimeout(() => navigate('/dashboard'), 3000);
        // } else {
        setTimeout(() => navigate('/login'), 5000); // Redirect to login after 5s
        // }

      } catch (err) {
        setError(err.response?.data?.detail || 'Email verification failed. The link might be expired, invalid, or the email already verified.');
        console.error("Email verification error:", err.response?.data || err.message);
      } finally {
        setIsLoading(false);
      }
    };
    verifyEmail();
  }, [key, navigate, login]);

  return (
    <div className="min-h-[calc(100vh-var(--navbar-height,88px)-var(--footer-height,88px))] flex flex-col items-center justify-center bg-gradient-to-b from-white to-blue-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8 text-center bg-white p-8 sm:p-10 shadow-xl rounded-lg border border-gray-200">
        <Link to="/" className="inline-block mb-6">
          <h1 className="text-3xl sm:text-4xl font-bold text-blue-600 hover:text-blue-700 transition-colors">Agent Digest</h1>
        </Link>
        <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-gray-900">
          Email Verification
        </h2>
        {isLoading && <LoadingSpinner />}
        {message && <p className="text-green-600 bg-green-100 p-3 rounded-md text-sm sm:text-base">{message}</p>}
        {error && <p className="text-red-600 bg-red-100 p-3 rounded-md text-sm sm:text-base">{error}</p>}
        {!isLoading && (
          <div className="mt-6">
            {message && <Link to="/login" className="font-semibold text-blue-600 hover:text-blue-500 text-sm sm:text-base">Proceed to Login</Link>}
            {error && (
                <>
                    <p className="text-sm text-gray-600 mt-4">
                        If you are having trouble, you can try to <Link to="/resend-email-verification" className="font-semibold text-blue-600 hover:text-blue-500">resend the verification email</Link> or <Link to="/contact-support" className="font-semibold text-blue-600 hover:text-blue-500">contact support</Link>.
                    </p>
                    <Link to="/login" className="mt-4 inline-block font-semibold text-blue-600 hover:text-blue-500 text-sm sm:text-base">Back to Login</Link>
                </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailVerificationPage;

